// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import {
  MODAL_TEMPLATES_OPTIONS,
  showModal,
  type ShowModalOptions,
} from '@shared/ui-kit/components/popups/show-modal';
import type { TFunction } from 'i18next';

export const alertUnavailableTrades = (t: TFunction) => {
  const errorMessage = (
    <>
      {t('research.unavailable-positions.message', { ns: 'research' })}
      <br />
      <br />
      {t('research.unavailable-positions.instruction', { ns: 'research' })}
    </>
  );

  showModal({
    ...MODAL_TEMPLATES_OPTIONS(t).CONFIRM_DELETE,
    title: t('research.unavailable-positions.title', { ns: 'research' }),
    content: errorMessage,
    buttons: {
      cancel: {
        show: true,
        text: t('common.cancel', { ns: 'common' }),
      },
      confirm: {
        show: true,
        text: t('common.reload', { ns: 'common' }),
      },
    },
  } as ShowModalOptions).then(({ isConfirmed }) => {
    if (isConfirmed) window.location.reload();
  });
};
